import { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../../_redux/student-level-section/StudentAssignmentAction";
import { StudentsPage } from "./students/StudentsPage";
import { Card, CardBody, CardHeader } from "../../../../../../_metronic/_partials/controls";
import { CustomSelect, getGradeOptions, GradeLevelOptions } from "../../../../../../_helpers/Helpers";

export function StudentAssignmentPage({
  history
}) {
  const [grade, setGrade] = useState();
  const [courseId, setCourseId] = useState();
  const [sectionId, setSectionId] = useState();
  const [gradeOptions, setGradeOptions] = useState([]);
  
  // Getting curret state of Student Assignment To Level Section from store (Redux)
  const dispatch = useDispatch();
  const { courses, sections } = useSelector(
    (state) => ({
      courses: state.studentLevelSection.courses,
      sections: state.studentLevelSection.sections,
    }),
    shallowEqual
  );
  
  useEffect(() => {
    return () => dispatch(actions.cleanCoursesAndSections());
  }, [dispatch]);
  
  return (
    <>
      <div className="row">
        <div className="col-6">
          <Card>
            <CardHeader title="Sınıf" />
            <CardBody>
              <div className="form-group row">
                <div className="col-4 mt-3">
                  Sınıf Düzeyi <span>*</span>
                </div>
                <div className="col-8">
                  <CustomSelect
                    options={GradeLevelOptions}
                    onChange={option => {
                      dispatch(actions.cleanCoursesAndSections());
                      setGradeOptions(getGradeOptions(option.value));
                      setGrade(null);
                      setCourseId(null);
                      setSectionId(null);
                    }}
                  />
                </div>
              </div>
              <div className="form-group row">
                <div className="col-4 mt-3">
                  Sınıf <span>*</span>
                </div>
                <div className="col-8">
                  <CustomSelect
                    options={gradeOptions}
                    value={grade}
                    onChange={option => dispatch(actions.getLevelCourses(option.value)).then(() => {
                      setGrade(option.value);
                      setCourseId(null);
                      setSectionId(null);
                    })}
                  />
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
        <div className="col-6">
          <Card>
            <CardHeader title="Kur Sınıfı" />
            <CardBody>
              <div className="form-group row">
                <div className="col-4 mt-3">
                  Kur Dersi <span>*</span>
                </div>
                <div className="col-8">
                  <CustomSelect
                    options={courses}
                    value={courseId}
                    onChange={option => dispatch(actions.getLevelSections(option.value)).then(() => {
                      setCourseId(option.value);
                      setSectionId(null);
                    })}
                  />
                </div>
              </div>
              <div className="form-group row">
                <div className="col-4 mt-3">
                  Kur <span>*</span>
                </div>
                <div className="col-8">
                  <CustomSelect
                    options={sections}
                    value={sectionId}
                    onChange={option => dispatch(actions.getRegistrationInfoIds(option.value)).then(() => setSectionId(option.value))}
                  />
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
      </div>
      <StudentsPage
        history={history}
        grade={grade}
        sectionId={sectionId}
      />      
    </>    
  );
}